import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnonymousConsentsService, BaseSiteService, ConsentService, CxEvent } from '@spartacus/core';
import { TmsCollector, WindowObject } from '@spartacus/tracking/tms/core';
import { combineLatest, map } from 'rxjs';
import { HjCollectorConfig } from './config/hj-collector.config';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class HjCollectorService implements TmsCollector {
  constructor(
    private environmentService: EnvironmentService,
    private consentService: ConsentService,
    private baseSiteService: BaseSiteService
  ) {}

  consentCookie$ = this.consentService.checkConsentGivenByTemplateId('ANALYTICS');

  init(config: HjCollectorConfig, windowObject: WindowObject): void {
    combineLatest([this.consentCookie$, this.baseSiteService.getActive()])
      .pipe(takeUntilDestroyed())
      .subscribe(([analyticsAllowed, activeSiteId]) => {
        const hjId: string | undefined = activeSiteId
          ? this.environmentService.getCurrentEnvironment().tracking.hotjar.analytics.id[activeSiteId]
          : undefined;

        if (analyticsAllowed && hjId) {
          // Defer Hotjar script loading to improve TTFB
          this.loadHotjarScript(windowObject, hjId);
        }
      });
  }

  private loadHotjarScript(windowObject: WindowObject, hjId: string): void {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => this.createHotjarScript(windowObject, hjId), { timeout: 5000 });
    } else {
      setTimeout(() => this.createHotjarScript(windowObject, hjId), 2000);
    }
  }

  private createHotjarScript(windowObject: WindowObject, hjId: string): void {
    // @ts-ignore
    (function (h: WindowObject, o: Document, t: string, j: string, a: any, r: any) {
      h['hj'] =
        h['hj'] ||
        function () {
          (h['hj'].q = h['hj'].q || []).push(arguments);
        };
      h['_hjSettings'] = {
        hjid: hjId,
        hjsv: 6,
      };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.defer = true;
      r.src = t + h['_hjSettings'].hjid + j + h['_hjSettings'].hjsv;
      a.appendChild(r);
    })(windowObject, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }

  pushEvent<T extends CxEvent>(config: HjCollectorConfig, windowObject: WindowObject, event: any): void {}
}
